
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","width":"12","height":"20","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"d":"M12.606 18.447H7.665c.18-.487.65-.835 1.2-.835h2.54c.55 0 1.02.348 1.2.835zM5.778 9.893a4.371 4.371 0 004.316 4.357c1.184-.005 2.276-.436 3.108-1.26a4.327 4.327 0 001.29-3.097h.89l-.005.23a5.207 5.207 0 01-1.55 3.498 5.208 5.208 0 01-3.247 1.497v1.605h.826c1.195 0 2.168.973 2.168 2.169v.444H6.696v-.444c0-1.196.973-2.169 2.169-2.169h.826v-1.607c-2.603-.222-4.679-2.36-4.797-4.986h-.005v-.237zM10.098.89c.963-.023 1.903.38 2.63 1.1.856.846 1.347 2.07 1.347 3.358v4.053c0 1.287-.49 2.511-1.346 3.358-.718.71-1.637 1.101-2.593 1.101H10.1c-2.154-.021-3.906-2.022-3.906-4.459V5.348c0-2.435 1.75-4.435 3.902-4.458zm.038.888h-.029c-1.572.018-2.867 1.445-3.01 3.245h1.94v.889H7.083v.802h1.952v.89H7.084v.802h1.952v.889H7.084V9.4c0 1.952 1.357 3.554 3.025 3.57.74-.002 1.438-.292 1.995-.843.688-.682 1.082-1.676 1.082-2.727v-.106h-1.828v-.89h1.828v-.802h-1.828v-.889h1.828v-.802h-1.828v-.89h1.813c-.073-.929-.45-1.79-1.068-2.4-.55-.545-1.248-.844-1.967-.844z","id":"listen-a"}})]),_c('g',{attrs:{"transform":"translate(-4)","fill":"none","fill-rule":"evenodd"}},[_c('mask',{attrs:{"id":"listen-b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#listen-a"}})]),_c('use',{attrs:{"fill":"#020203","xlink:href":"#listen-a"}}),_c('g',{attrs:{"mask":"url(#listen-b)","fill":"#000"}},[_c('path',{attrs:{"d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    